export default __webpack_public_path__ + "static/media/sign_in_4.4adc6a92.png";